//

export const convertTimestampToDate = timestamp => {
  let monthNames = [
    'JAN',
    'FEB',
    'MAR',
    'APR',
    'MAY',
    'JUN',
    'JULY',
    'AUG',
    'SEP',
    'OCT',
    'NOV',
    'DEC',
  ];
  let date = new Date(timestamp);
  let day = date.getDate();
  let monthIndex = date.getMonth();
  let month = monthNames[monthIndex];
  let year = date.getFullYear();
  let hours = date.getHours() || 0;
  let cleanHours;
  if (hours === 0) {
    cleanHours = 12; // if timestamp is between midnight and 1am, show 12:XX am
  } else {
    cleanHours = hours > 12 ? hours - 12 : hours; // else show proper am/pm -- todo: support 24hr time
  }
  let minutes = date.getMinutes();
  minutes = minutes >= 10 ? minutes : '0' + minutes.toString(); // turns 4 minutes into 04 minutes
  let ampm = hours >= 12 ? 'pm' : 'am'; // todo: support 24hr time
  return `${day} ${month} ${year} at ${cleanHours}:${minutes} ${ampm}`;
};

export const convertTimestampToTime = timestamp => {
  let date = new Date(timestamp);
  let hours = date.getHours() || 0;
  let cleanHours;
  if (hours === 0) {
    cleanHours = 12; // if timestamp is between midnight and 1am, show 12:XX am
  } else {
    cleanHours = hours > 12 ? hours - 12 : hours; // else show proper am/pm -- todo: support 24hr time
  }
  let minutes = date.getMinutes();
  minutes = minutes >= 10 ? minutes : '0' + minutes.toString(); // turns 4 minutes into 04 minutes
  let ampm = hours >= 12 ? 'pm' : 'am'; // todo: support 24hr time
  return `${cleanHours}:${minutes}${ampm}`;
};

export const formatTime = timestamp => {
  let date = new Date(timestamp);
  var minute = 1000 * 60,
    hour = minute * 60,
    day = hour * 24,
    halfamonth = day * 15,
    month = day * 30,
    year = month * 12;
  const now = new Date().getTime();
  const diffValue = now - date;
  var yearC = diffValue / year,
    monthC = diffValue / month,
    weekC = diffValue / (7 * day),
    dayC = diffValue / day,
    hourC = diffValue / hour,
    minC = diffValue / minute;

  if (yearC >= 2) {
    return parseInt(yearC) + ' years ago';
  } else if (yearC >= 1) {
    return parseInt(yearC) + ' year ago';
  } else if (monthC >= 2) {
    return parseInt(monthC) + ' months ago';
  } else if (monthC >= 1) {
    return parseInt(monthC) + ' month ago';
  } else if (weekC >= 2) {
    return parseInt(weekC) + ' weeks ago';
  } else if (weekC >= 1) {
    return parseInt(weekC) + ' week ago';
  } else if (dayC >= 2) {
    return parseInt(dayC) + ' days ago';
  } else if (dayC >= 1) {
    return parseInt(dayC) + ' day ago';
  } else if (hourC >= 2) {
    return parseInt(hourC) + ' hours ago';
  } else if (hourC >= 1) {
    return parseInt(hourC) + ' hour ago';
  } else if (minC >= 2) {
    return parseInt(minC) + ' mins ago';
  } else if (minC >= 1) {
    return parseInt(minC) + ' min ago';
  }
  return 'just now';
};
